<template>
  <div class="contenedor" style="background-color: #f6f3ee; padding-top: 60px;">
    <!-- Texto central con control de tamaño -->
    <div class="text-container">
      <div class="texto-title">
        Conoce tu Kia Ideal sin salir de tu casa u oficina en solo 2 pasos
      </div>
    </div>

    <!-- Dos recuadros con ícono y texto -->
    <div class="box-container">
      <div class="info-box" style="background-color: #e6e7e8;">
        <span class="icon">
          <img src="@/assets/images/icons-02.svg" alt="Icono Kia" class="icon-img" />
        </span>
        <div class="label">Escoge el día y hora para tu cita virtual en donde un KIA Expert te explicará los detalles del vehículo de tu elección.</div>
      </div>
      <div class="info-box" style="background-color: #f8f8f8;">
        <span class="icon">
          <img src="@/assets/images/icons-03.svg" alt="Icono Kia" class="icon-img-2" />
        </span>
        <div class="label">Recibirás un mensaje de confirmación a tu correo electrónico. No olvides conectarte al link el día de la cita. </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fontSize: 24
    };
  }
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: #f6f6f6;
  min-height: 100vh;
}

.text-container {
  text-align: center;
  margin-bottom: 40px;
}

.central-text {
  margin-top: 10px;
  font-weight: bold;
  color: #333;
}

.box-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.info-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Alinea desde arriba */
  align-items: center;
  text-align: center;
  padding: 20px;
  max-width: 300px;
  box-sizing: border-box;
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px; /* Espacio uniforme para el ícono */
  margin-bottom: 10px;
}

.label {
  font-size: 16px;
  font-weight: 500;
  word-break: break-word;
}

/* Responsive */
@media (max-width: 600px) {
  .info-box {
    width: 100%;
    max-width: 300px;
  }
}

.texto-title {
  display: flex;
  justify-content: center;
  font-size: 35px;
  font-weight: bold;
  text-align: center;

}

.icon-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  filter: grayscale(100%) brightness(0);
}

.icon-img-2 {
  width: 100px;
  height: 100px;
  object-fit: contain;
  filter: grayscale(100%) brightness(0); 
}
</style>
